'use client';

import React from 'react';
import NextLink from 'next/link';
import { Button, Link, Stack, Typography } from '@unity/cloud-ui';
import type { ProductHeaderDataType } from '@/lib/content-loader/types';

export const ProductHeaderDesktop = (props: ProductHeaderDataType) => {
  const { title, quickAccess, callToAction } = props;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
      <Stack direction="row" gap={2} alignItems="center" marginLeft={1}>
        <Typography variant="h3">{title}</Typography>
        {quickAccess?.map(({ title, href }) => (
          <Button color="default" component={NextLink} key={title} href={href} sx={{ '&:hover': { color: 'inherit' } }}>
            <Typography
              color="text.secondary"
              variant="h3"
              fontSize="0.875rem"
              fontWeight={500}
              lineHeight="1.75rem"
              letterSpacing={0}
            >
              {title}
            </Typography>
          </Button>
        ))}
      </Stack>
      {callToAction && (
        <Button
          variant="contained"
          color="primary"
          component={Link}
          href={callToAction.href}
          external
          sx={({ vars }) => ({ '&:hover': { color: vars.palette.primary.buttonContrastText } })}
        >
          {callToAction.title}
        </Button>
      )}
    </Stack>
  );
};
